export const pageTitle = (title) => {
  const pageTitle = title ? `${title} ` : ''
  return ( document.title = pageTitle + "MAVS.TECH - Technologies That Change The World");
}